import { useApp, useBehavior, useTriggerAction, useUpdateWidgetValue } from '@libs/hooks';
import { TButtonData, TWidgetProps } from '@libs/types';
import clsx from 'clsx';
import React, { Activity } from 'react';
import { TButtonOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import { TextCommon } from '../UI/Text/TextCommon';
import { ButtonMessageBottomSheet } from './ButtonMessageBottomSheet';
import styles from './styles/buttonMessage.module.css';

export const ButtonMessage = ({ widget }: TWidgetProps<TButtonData, TButtonOption>) => {
    const { setPopup } = useApp();
    const { isDisabled, isHidden } = useBehavior(widget);
    const { triggerAction } = useTriggerAction(widget);
    const { updateWidgetValue } = useUpdateWidgetValue(widget);
    const data = widget.data ?? {};
    const options = widget.options ?? {};
    const initialValue = (data?.value as string) ?? '';

    return (
        <Activity mode={isHidden ? 'hidden' : 'visible'}>
            <button
                data-test={widget.uid}
                className={clsx(styles.messageButton, isDisabled && styles.messageButtonDisabled)}
                style={getInlineStyles({ margin: options.margin })}
                disabled={isDisabled}
                aria-label={initialValue || data.messages?.label}
                aria-disabled={isDisabled}
                aria-hidden={isHidden}
                onClick={() =>
                    setPopup?.(
                        <ButtonMessageBottomSheet
                            initialValue={initialValue}
                            uid={widget.uid}
                            maxLength={options.maxLength}
                            actions={widget.actions}
                            text={data.messages?.bottomSheetText}
                            buttonLabel={data.messages?.bottomSheetButtonLabel}
                            setPopup={setPopup}
                            triggerAction={triggerAction}
                            setValue={(val) => updateWidgetValue(val)}
                        />,
                    )
                }
            >
                <TextCommon
                    isWidget={false}
                    content={initialValue || data.messages?.label}
                    options={{ variant: 'main', textColor: initialValue ? 'black' : 'purple_100' }}
                />
                <span className={styles.corner}>
                    <svg className={styles.styledSvg} width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M27 17.0486C11.2909 17.0486 7.85455 5.51573 6.87273 0L0 6.51858C5.89091 20.0572 18.6545 18.5529 27 17.0486Z" />
                    </svg>
                </span>
            </button>
        </Activity>
    );
};
